module.exports = __webpack_public_path__ + "static/img/notice-bg01.ae96b851.png";